var EventStream = require('./lib/event_stream');
module.exports = new EventStream();
